export default {
  badge: 'Test',
  badge_title: 'Testrestaurant',
  notice: 'Dit is een testrestaurant. Hier geplaatste bestellingen zijn bedoeld voor testdoeleinden.',
};
